import React, {
    Component,
    createRef,
} from 'react'
import classnames from 'classnames'

export default class Icon extends Component {
    constructor(props) {
        super(props)

        this.state = {
            iconColor: null,
        }

        this.icon = createRef()
    }

    /**
     * After mount set icon color based on text color
     */
    componentDidMount() {
        if (this?.icon?.current) {
            this.setState({
                iconColor: window.getComputedStyle(this?.icon?.current)?.color,
            })
        }
    }

    /**
     * Get styles for svg element
     *
     * @return {{svg: {verticalAlign: string, display: string}}}
     */
    getStyles = () => {
        const {
            iconColor,
        } = this.state

        let styles = {
            svg: {
                display: 'inline-block',
                verticalAlign: 'middle',
            },
        }

        if (iconColor) {
            styles.path = {}
            styles.path.fill = iconColor
        }

        return styles
    }

    /**
     * Render
     *
     * @return {*}
     */
    render = () => {
        const {
            className,
            svg,
            size,
            icon,
        } = this.props

        const styles = this.getStyles()

        return (
            <svg
                className={classnames({
                    'icon': true,
                    [className]: !!className,
                })}
                style={svg || styles.svg}
                width={`${size ?? 16}px`}
                height={`${size ?? 16}px`}
                viewBox="0 0 1024 1024"
                ref={this.icon}
            >
                {icon.map((path, idx) =>
                    <path
                        key={idx}
                        style={styles.path}
                        d={path}
                    />
                )}
            </svg>
        )
    }
}
